export default {
  username: [{
    rule: 'required',
    error: 'Username is required',
  }],
};



// WEBPACK FOOTER //
// ./src/containers/pages/Auth/emailFormSchema.js